import React from "react";
import EfficiencyZone from "../EfficiencyZone/EfficiencyZone";
import "./TimeQualityReport.scss";

const TimeQualityReport = ({ zones = [] }) => {
  return (
    <div className="efficiency-chart">
      <div className="axis-left">Incorrect</div>
      <div className="axis-right">Correct</div>

      {zones.length === 4 && (
        <>
          {/* Mastery Zone (Fast & Correct) */}
          <EfficiencyZone
            percentage={parseFloat(zones[0].percentage)}
            title={zones[0].zone_name}
            subtitle={zones[0].zone_type}
            color="#16A34A"
          />

          {/* Efficiency Zone (Slow & Correct) */}
          <EfficiencyZone
            percentage={parseFloat(zones[1].percentage)}
            title={zones[1].zone_name}
            subtitle={zones[1].zone_type}
            color="#3B82F6"
          />

          {/* Caution Zone (Fast & Incorrect) */}
          <EfficiencyZone
            percentage={parseFloat(zones[2].percentage)}
            title={zones[2].zone_name}
            subtitle={zones[2].zone_type}
            color="#E9B008"
          />

          {/* Struggle Zone (Slow & Incorrect) */}
          <EfficiencyZone
            percentage={parseFloat(zones[3].percentage)}
            title={zones[3].zone_name}
            subtitle={zones[3].zone_type}
            color="#EF4444"
          />
        </>
      )}
    </div>
  );
};

export default TimeQualityReport;
